module.exports = __webpack_public_path__ + "img/slider5.1acb601c.jpg";